import type { StageId } from '@kdk/shared';

/** 段階ごとの開始旬(最初に現れた旬)。現れた順に返す。 */
export const stageStarts = (
  stages: readonly (StageId | null)[],
): { stage: StageId; slot: number }[] => {
  const seen = new Set<StageId>();
  const out: { stage: StageId; slot: number }[] = [];
  stages.forEach((stage, slot) => {
    if (stage !== null && !seen.has(stage)) {
      seen.add(stage);
      out.push({ stage, slot });
    }
  });
  return out;
};
